var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97813 9.97188C9.97813 8.98438 9.21355 8.75 8.36459 8.75H6.15521V11.25H8.5375C9.38021 11.25 9.97813 10.8813 9.97813 9.97188Z",
    fill: "#7131FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3604 11.2667C16.3396 11.2667 15.6583 11.9031 15.5917 12.924H19.0625C18.9677 11.8917 18.4323 11.2667 17.3604 11.2667Z",
    fill: "#7131FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71666 13.0302H6.14999V15.9823H8.66666C9.62708 15.9823 10.4083 15.6417 10.4083 14.5646C10.4073 13.4656 9.75416 13.0354 8.71666 13.0302Z",
    fill: "#7131FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5729 0.3125H4.42708C1.97917 0.3125 0 2.29167 0 4.73958V20.2604C0 22.7083 1.97917 24.6875 4.42708 24.6875H20.5729C23.0208 24.6875 25 22.7083 25 20.2604V4.73958C25 2.29167 23.0208 0.3125 20.5729 0.3125ZM15.1615 7.48333H19.5031V8.5375H15.1615V7.48333ZM8.98958 17.8125H3.79479V7.09792H8.84479C10.6812 7.09792 12.2708 7.61667 12.2708 9.74792C12.2708 10.825 11.7688 11.3552 10.8083 11.8125C12.125 12.1865 12.7615 13.3479 12.7615 14.6927C12.7625 16.8698 10.9375 17.801 8.98958 17.8125ZM21.1885 14.2687H15.5969C15.5969 15.5073 16.25 16.2385 17.5 16.2385C18.1469 16.2385 18.9792 15.8927 19.1854 15.2281H21.0656C20.4854 17.0083 19.2854 17.8396 17.4333 17.8396C14.9896 17.8396 13.4656 16.1823 13.4656 13.7656C13.4656 11.4333 15.0677 9.65937 17.4333 9.65937C19.8604 9.65937 21.2052 11.5729 21.2052 13.8667C21.2052 14.001 21.1937 14.1406 21.1885 14.2687Z",
    fill: "#7131FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceIcon);
export default __webpack_public_path__ + "static/media/behance_icon.79cba7762fee7fd787f84452b92c18bc.svg";
export { ForwardRef as ReactComponent };